import { SVGProps } from 'react';

export type TokenIconProps = SVGProps<SVGSVGElement> & {
  color?: string;
};

export const TokenIcon = ({ color = '#27584D', ...props }: TokenIconProps) => (
  <svg width="31" height="33" viewBox="0 0 31 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M28.7833 7.71634L15.5 0.333008L2.21667 7.71634L10.6667 12.3997C11.8833 11.133 13.6 10.333 15.5 10.333C17.4 10.333 19.1167 11.133 20.3333 12.3997L28.7833 7.71634ZM12.1667 16.9997C12.1667 15.1663 13.6667 13.6663 15.5 13.6663C17.3333 13.6663 18.8333 15.1663 18.8333 16.9997C18.8333 18.833 17.3333 20.333 15.5 20.333C13.6667 20.333 12.1667 18.833 12.1667 16.9997ZM13.8333 32.733L0.5 25.333V10.5663L9.05 15.3163C8.9 15.8497 8.83333 16.4163 8.83333 16.9997C8.83333 20.0997 10.95 22.7163 13.8333 23.4497V32.733ZM17.1667 32.733V23.4497C20.05 22.7163 22.1667 20.0997 22.1667 16.9997C22.1667 16.4163 22.1 15.8497 21.95 15.3163L30.5 10.5663V25.333L17.1667 32.733Z"
      fill={color}
    />
  </svg>
);
